import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from '../components/components.module';
import { DfAlertModule, DfSelectModule } from '@design-factory/design-factory';
import { PointsOfSaleModule } from '../points-of-sale/points-of-sale.module';
import { HotelsCreateComponent } from './hotels-create/hotels-create.component';
import { HotelsDisplayComponent } from './hotels-display/hotels-display.component';
import { HotelsAppComponent } from './hotels-app.component';
import { HotelsRoutingModule } from './hotels-routing.module';
import { HotelsDetailsComponent } from './hotels-details/hotels-details.component';
import { HotelsSearchComponent } from './hotels-search/hotels-search.component';
import { HotelsSearchCriteriaComponent } from './hotels-search/hotels-search-criteria/hotels-search-criteria.component';
import { HotelsModifyComponent } from './hotels-modify/hotels-modify.component';
import { HotelDetailsV2Component } from './hotels-v2/hotel-details-v2/hotel-details-v2.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    ComponentsModule,
    DfSelectModule,
    PointsOfSaleModule,
    HotelsRoutingModule,
    DfAlertModule,
    HotelsCreateComponent,
    HotelsModifyComponent,
    HotelsDisplayComponent,
    HotelsAppComponent,
    HotelsDetailsComponent,
    HotelsSearchComponent,
    HotelsSearchCriteriaComponent,
    HotelDetailsV2Component
  ],
  exports: [HotelsCreateComponent, HotelsDisplayComponent]
})
export class HotelsModule {}
